import { httpPost } from "@/request/http";
import func from "@/funcs";

export default function (url, formData, timeout, showSuccessMessage = true) {
  let headers = { "Content-Type": "multipart/form-data" };
  if (timeout != undefined) headers.timeout = timeout;
  return new Promise((resolve, reject) => {
    httpPost(url, formData, headers)
      .then((data) => {
        let errortext = "";
        if (data.ErrorText) {
          errortext = `\n\n` + data.ErrorText;
        }
        if (showSuccessMessage) {
          func.message({
            type: "success",
            mainMessage: "匯入成功 !" + errortext,
          });
        }
        resolve(data);
      })
      .catch((response) => {
        if (!Array.isArray(response.data)) {
          func.message({
            type: "error",
            mainMessage: response.data.Message,
          });
        }
        reject(response);
      });
  });
}
